import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import AddressForm from '../../features/components/AddressForm/AddressForm';

interface EntityAddressFormProps {
  onlyAustralia?: boolean;
  optional?: boolean;
  disableManual?: boolean;
  prefix?: string;
}

export function EntityAddressForm({
  onlyAustralia = true,
  optional = false,
  disableManual = true,
  prefix = '',
}: EntityAddressFormProps) {
  const { t } = useTranslation();

  // Build the entity address field path based on prefix
  const addressFieldPath = prefix
    ? `${prefix}entity.address`
    : 'entity.address';

  const inputs = useMemo(
    () => ({
      address: {
        label: t('address', { ns: 'contacts' }),
        name: addressFieldPath as any,
        type: 'text',
        placeholder: t('addressPlaceholder', { ns: 'contacts' }),
        defaultValue: '',
      },
    }),
    [t, addressFieldPath]
  );
  return (
    <AddressForm
      label={inputs.address.label}
      placeholder={inputs.address.placeholder}
      optional={optional}
      onlyAustralia={onlyAustralia}
      name={inputs.address.name}
      disableManual={disableManual}
    />
  );
}

export default EntityAddressForm;
